import React, { useEffect, useRef, useState } from "react";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import mammoth from "mammoth";
import { envConfig } from "../services/configs/envConfig";


const TermsOfUsePanel = ({ onAccept, onDecline }) => {

  const [html, setHtml] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [scrolledToBottom, setScrolledToBottom] = useState(false);
  const contentRef = useRef(null);
  const TERMS_FILE = envConfig.TermsUrl;
  useEffect(() => {
    console.log("Dock url",TERMS_FILE);
    fetch(TERMS_FILE)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to load terms document.");
        return res.arrayBuffer();
      })
      .then((buffer) => mammoth.convertToHtml({ arrayBuffer: buffer }))
      .then((result) => {
        setHtml(result.value);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message || "Could not load the Terms of Use.");
        setLoading(false);
      });
  }, []);

  const handleScroll = () => {
    const el = contentRef.current;
    if (!el) return;
    if (el.scrollHeight - el.scrollTop <= el.clientHeight + 10) {
      setScrolledToBottom(true);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: 580,
        mx: "auto",
        mt: 6,
        mb: 4,
        px: 2,
      }}
    >
      <Typography component="h1" variant="h6" sx={{ mb: 0.5 }}>
        Terms of Use
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ mb: 1.5 }}>
        Please read and scroll to the bottom to enable the Accept button.
      </Typography>

      <Divider sx={{ mb: 1.5 }} />

      {/* Scrollable terms content */}
      <Box
        ref={contentRef}
        onScroll={handleScroll}
        sx={{
          height: 580,
          overflowY: "auto",
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 1,
          p: 1.5,
          mb: 1.5,
          backgroundColor: "grey.50",
          fontSize: "0.78rem",
        }}
      >
        {loading && (
          <Box display="flex" justifyContent="center" alignItems="center" height="200px">
            <CircularProgress />
          </Box>
        )}
        {error && (
          <Alert severity="error">{error}</Alert>
        )}
        {!loading && !error && (
          <Box
            sx={{
              "& p": { mb: 1, fontSize: "0.78rem" },
              "& h1": { fontSize: "0.95rem", mt: 1.5, mb: 0.5, fontWeight: 600 },
              "& h2": { fontSize: "0.88rem", mt: 1.5, mb: 0.5, fontWeight: 600 },
              "& h3": { fontSize: "0.82rem", mt: 1, mb: 0.5, fontWeight: 600 },
              "& ul, & ol": { pl: 2.5, mb: 1, fontSize: "0.78rem" },
            }}
            dangerouslySetInnerHTML={{ __html: html }}
          />
        )}
      </Box>

      {!scrolledToBottom && !loading && !error && (
        <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, textAlign: "center" }}>
          Scroll to the bottom to enable Accept
        </Typography>
      )}

      <Stack direction="row" spacing={2}>
        <Button
          fullWidth
          variant="outlined"
          color="error"
          onClick={onDecline}
        >
          Decline
        </Button>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          disabled={!scrolledToBottom}
          onClick={onAccept}
          sx={{ borderRadius: "50px" }}
        >
          Accept &amp; Continue
        </Button>
      </Stack>
    </Box>
  );
};

export default TermsOfUsePanel;
